export default __webpack_public_path__ + "static/media/notShowOperativeCode.69338a0c.png";